module.exports = __webpack_public_path__ + "img/feature_buy_th.ad39c613.png";